var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPinMap = function SvgPinMap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Artboard Copy")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Location-Pin",
    transform: "translate(6.000000, 5.000000)",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.7607,0.3 C7.2193,0.3 8.7672,0.92016 9.857,2.0622 C10.9665,3.22487 11.5819,4.91013 11.1715,6.9627 L11.1715,6.9627 C10.7634,8.7999 9.4695,10.4608 8.356,11.6211 C7.7892,12.2117 7.2472,12.6949 6.8466,13.0307 L6.8466,13.0307 L6.188,13.5546 L6.1774,13.5625 L6.1742,13.5648 C6.17275714,13.5658429 6.17343061,13.5683312 6.17069582,13.566939 L5.7543,13.8703 L5.34298964,13.5614404 C5.33826144,13.5597764 5.33636667,13.5567413 5.3355,13.5561 L5.3355,13.5561 L5.3241,13.5475 L5.2835,13.5162 C5.2486,13.4893 5.1986,13.4502 5.1356,13.3998 C5.0095,13.2991 4.8307,13.1528 4.616,12.9674 C4.1872,12.5973 3.61058,12.0677 3.02038,11.4301 C1.86959,10.1868 0.54744,8.4073 0.33911,6.5318 C-0.07519,2.80223 2.84245,0.3 5.7607,0.3 Z",
    id: "Shape",
    stroke: "#2F353B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E34B34",
    fill: "#E34B34",
    fillRule: "nonzero",
    cx: 5.8,
    cy: 5.8,
    r: 1.5
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPinMap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pin-map.a99facc7.svg";
export { ForwardRef as ReactComponent };